import loadable from '@loadable/component';

export const NewsPage = loadable(/* #__LOADABLE__ */ () => import('./NewsPage'));
